export const getInitials = (name: string): string => {
  const nameWithSpaces = name.replace(',', ' ');
  const parts = nameWithSpaces.split(' ');
  const nonEmptyParts = parts.filter((part) => part.trim() !== '');
  const initials = nonEmptyParts.map((part) => part[0].toUpperCase());

  return initials.slice(0, 2).join('');
};
